import { Route, Routes } from 'react-router-dom';
import './App.css';
import Root from './components/layouts/root';
import { ApolloConnection } from './components/shared/apollo-connection';
import MaintenanceMessageProvider from './components/shared/maintenance-message';
import RequireAuth from './components/shared/require-auth';
import { Staff } from './components/layouts/staff';
import { IdleTimer } from './components/shared/idle-timer';
import { AuthLanding } from './components/shared/auth-landing';
import { Helmet } from 'react-helmet';

function App() {
  const authSection = (
    <RequireAuth redirectPath="/" forceLogin={true}>
      <AuthLanding />
    </RequireAuth>
  );

  const rootSection = <Root />;

  const staffSection = (
    <RequireAuth redirectPath="/" forceLogin={true}>
      <IdleTimer>
        <Staff />
      </IdleTimer>
    </RequireAuth>
  );

  return (
    <>
      <Helmet titleTemplate="CVHP: %s" />
      <ApolloConnection>
        <MaintenanceMessageProvider>
          <Routes>
            <Route path="*" element={rootSection} />
            <Route path="/auth-redirect" element={authSection} />
            <Route path="/staff/*" element={staffSection} />
          </Routes>
        </MaintenanceMessageProvider>
      </ApolloConnection>
    </>
  );
}

export default App;
